import { loadOptions } from '../formset.js';

export default function (...args)
{
	return {
		options: [
			{ value: '1', label: 'Contribuinte' },
			{ value: '2', label: 'Isento' },
			{ value: '9', label: 'Não Contribuinte' },
		],
		captureEvents(_this = this)
		{
			loadOptions(this.selector, this.options);
			this.safeProtoCall(_this);
		}
	};
}

